import {
  Component,
  OnInit,
  ComponentRef,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { IMenu } from '../models/imenu.model';
import { Observable, from } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { EventListenerService } from '../services/close-listenenr.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services';

declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-about-info',
  templateUrl: './about-info.component.html',
  styleUrls: ['./about-info.component.css']
})
export class AboutInfoComponent implements OnInit, OnDestroy {
  MENULIST: IMenu[] = [
    {
      menuName: 'ABOUT US',
      menuIcon: 'far fa-circle',
      menuRouter: 'aboutus'
    },
    // TODO: here is list all the shopping cart list, have a call backend function while click
    {
      menuName: 'CONTACT US',
      menuIcon: 'far fa-circle',
      menuRouter: 'contactus'
    },
    {
      menuName: 'FREIGHT',
      menuIcon: 'far fa-circle',
      menuRouter: 'freight'
    },
    {
      menuName: 'INVESTORS',
      menuIcon: 'far fa-circle',
      menuRouter: 'investors'
    },
    {
      menuName: 'NEWS',
      menuIcon: 'far fa-circle',
      menuRouter: 'news'
    },
    {
      menuName: 'VENDORS',
      menuIcon: 'far fa-circle',
      menuRouter: 'vendors'
    }
  ];

  menulist$: Observable<IMenu[]>;
  title = 'ABOUT';
  created = false;
  // closesub$;
  // the component can be any instance of the child component in the second menu
  component: ComponentRef<any>;

  // tslint:disable-next-line:no-trailing-whitespace
  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

  // css variable
  setFullWindow = false;
  subWidth: string;

  searchField = '';

  isAU: boolean;
  currentUserModel: CurrentUserModel;

  constructor(
    private closeListener: EventListenerService,
    private resolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef,
    private commonService: CommonService,
    private activeRouter: ActivatedRoute,
    private authService: AuthService
  ) {
    commonService.emitUpdateSideBarActiveItem('about');
    this.menulist$ = from([this.MENULIST]);
  }

  ngOnInit() {
    console.log('about component init');

    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
      this.isAU = this.currentUserModel.isAU;
      if(this.isAU) {
        this.openInNewTab('https://www.dickerdata.com.au/Home/Index');
      }
      else {
        this.openInNewTab('https://www.dickerdata.co.nz/about-us');
      }
    },
      (error: any) => {
        console.info(error);
      });
      
      // this.openInNewTab('https://www.dickerdata.com.au/Home/Index');

    this.activeRouter.url.subscribe(value => {
      // console.log('the router ins :', value[0].path);
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }
    });

    // note: below is only used in the buy component, product search result
    // if (localStorage.getItem('searchItem')) {
    //   console.log('need to search ');
    //   // this.cre
    //   this.searchField = localStorage.getItem('searchItem');
    //   localStorage.removeItem('searchItem');
    //   // this.showSearchResult(this.searchField);
    // }
  }

  // TODO:
  // need to add the dbouncetime event on the observable
  filterMenu(menuName: string) {
    if (menuName.length > 0) {
      console.log('hahah', menuName);
      this.menulist$ = from([
        this.MENULIST.filter(item => {
          return (
            item.menuName.toUpperCase().indexOf(menuName.toUpperCase()) >= 0
          );
        })
      ]);
      // .pipe(debounceTime(1000));
      // .debounceTime(1000);
    } else {
      this.menulist$ = from([this.MENULIST]);
    }
  }

  ngOnDestroy(): void {
    this.commonService.emitUpdateSideBarActiveItem('');
    // this.closesub$.unsubscribe();
  }
  openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
  }
  close() {
    this.entry.clear();
    this.created = false;
  }
}
